import type {
  EmbargoMode,
  EmbargoShipmentContext,
  EmbargoValidationContext,
} from './types';

type ShipmentInfoLike = {
  pickupShipmentRowId?: string;
  destinationZip?: string | null;
  destinationTerminal?: string | null;
  destinationCity?: string | null;
  destinationState?: string | null;
  consigneeCode?: string | null;
  isFreezable?: boolean | null;
};

type BuildEmbargoFormContextOptions = {
  mode: EmbargoMode;
  shipments: ShipmentInfoLike[] | null | undefined;
};

const buildShipmentContext = (
  shipment: ShipmentInfoLike,
  index: number
): EmbargoShipmentContext | null => {
  const destinationZip = shipment.destinationZip ?? '';
  const destinationTerminal = shipment.destinationTerminal ?? '';
  const consigneeCode = shipment.consigneeCode ?? '';
  const isFreezable = shipment.isFreezable === true;
  if (!destinationZip && !destinationTerminal && !isFreezable && !consigneeCode) {
    return null;
  }

  return {
    rowId: shipment.pickupShipmentRowId ?? `row-${index}`,
    destinationZip,
    destinationTerminal,
    destinationCity: shipment.destinationCity ?? '',
    destinationState: shipment.destinationState ?? '',
    consigneeCode,
    isFreezable,
  };
};

export const buildEmbargoFormContext = ({
  mode,
  shipments,
}: BuildEmbargoFormContextOptions): EmbargoValidationContext => {
  const shipmentContexts = (shipments ?? [])
    .map((shipment, index) => buildShipmentContext(shipment, index))
    .filter((shipment): shipment is EmbargoShipmentContext => Boolean(shipment));

  return {
    mode,
    shipments: shipmentContexts,
  };
};
